module.exports = __webpack_public_path__ + "static/img/jojoprocurement.57b1a46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/jojoprocurement.png
// module id = 52Q1
// module chunks = 46